import { createStructuredSelector } from 'reselect'
import { selectOrderedCountries, selectSegments } from '../../../store'

export const selectLead = createStructuredSelector({
  segments: selectSegments,
  countries: selectOrderedCountries,
})
